import {AccessTime} from '@material-ui/icons';
import React from 'react';

interface IExpireIconProps {
  disabled?: boolean;
}

export function ExpireIcon({disabled}: IExpireIconProps) {
  return <AccessTime fontSize="small" style={{opacity: disabled ? 0.3 : 1, color: '#FFD700'}} />;
}
